export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  region: string;
  type: string;
  imageUrl: string;
  tags: string[];
  publishedAt: string;
  rating: number;
  views: number;
  authorName: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《星际穿越》十周年回顾：诺兰的时空诗学与人类情感',
    excerpt: '克里斯托弗·诺兰执导的科幻巨制《星际穿越》上映十周年，这部融合了物理学、哲学与人类情感的杰作至今仍令人回味无穷。本文从时空叙事、情感内核与视觉美学三个维度，重新审视这部经典。',
    content: `<p>2014年上映的《星际穿越》无疑是21世纪最具野心的科幻电影之一。导演克里斯托弗·诺兰与诺贝尔物理学奖得主基普·索恩合作，将黑洞、虫洞、时间膨胀等前沿物理学概念融入一个关于爱与生存的宏大叙事中。</p><p>影片讲述了未来地球面临粮食危机与生态崩溃，前NASA飞行员库珀被选中穿越虫洞，前往遥远星系为人类寻找新家园的故事。马修·麦康纳用精湛的演技诠释了一个父亲在拯救人类与陪伴女儿之间的痛苦抉择。</p><p>汉斯·季默的配乐堪称神来之笔，管风琴的庄严音色赋予影片一种宗教般的崇高感。而摄影师霍伊特·范·霍特玛用IMAX摄影机捕捉的壮丽太空画面，至今仍是科幻电影美学的标杆。</p><p>十年来，《星际穿越》对"时间"这一主题的探讨持续引发观众深思——当库珀从米勒星球返回时，短短几小时已等于地球上的23年。这种时间的残酷与温柔，正是诺兰对人性最深刻的洞察。</p>`,
    categoryId: 'oumei-movies',
    categoryName: '欧美电影',
    region: '欧美',
    type: '电影',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20scene%20with%20wormhole%20and%20distant%20galaxy%2C%20soft%20ambient%20lighting%2C%20minimalist%20composition%2C%20warm%20golden%20tones%2C%20ethereal%20atmosphere%2C%20editorial%20photography%20style%20with%20clean%20background%2C%20no%20text&width=800&height=450&seq=interstellar-review-2026&orientation=landscape',
    tags: ['科幻', '诺兰', '经典回顾', 'IMAX'],
    publishedAt: '2026-08-08',
    rating: 9.3,
    views: 125800,
    authorName: '影评人小林',
  },
  {
    id: 'article-2',
    title: '2026夏季日剧推荐：这五部作品绝对不能错过',
    excerpt: '2026年夏季日剧档精彩纷呈，从社会派悬疑到温暖治愈，从漫改大作到原创剧本，本季五部必追日剧全面解析，带你提前锁定追剧清单。',
    content: `<p>2026年夏季日剧档已经全面开启，各大电视台与流媒体平台纷纷推出重磅作品。经过首周播出后的口碑沉淀，我们精选了五部值得关注的佳作。</p><p><strong>《沉默的证人》</strong>——TBS周日剧场推出的社会派悬疑剧，由佐藤健主演，讲述一名法医在解剖过程中发现的连环案件线索，每集一个案件，主线悬念贯穿全季。剧本扎实，表演到位，是目前口碑最佳的作品。</p><p><strong>《夏日烟火与柠檬汽水》</strong>——富士台月九纯爱剧，改编自同名畅销小说，由新生代演员杉咲花与道枝骏佑主演，讲述海边小镇一段青涩而深刻的夏日恋情。</p><p><strong>《东京迷宫》</strong>——WOWOW出品的暗黑犯罪剧，以东京地下社会为舞台，影像风格冷峻，剧情紧凑，是犯罪剧爱好者的不二之选。</p><p>此外，《重启人生的我们》与《京都料理人》也分别以奇幻喜剧与美食治愈的定位收获了不俗口碑。这个夏天，日剧迷们有福了。</p>`,
    categoryId: 'japan-tv',
    categoryName: '日本剧集',
    region: '日本',
    type: '剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20summer%20evening%20cityscape%20with%20warm%20paper%20lanterns%2C%20soft%20ambient%20lighting%2C%20minimalist%20composition%2C%20cinematic%20mood%2C%20clean%20background%2C%20editorial%20photography%20style%2C%20no%20text&width=800&height=450&seq=japan-summer-drama-2026&orientation=landscape',
    tags: ['日剧', '夏季档', '推荐', '2026'],
    publishedAt: '2026-08-06',
    rating: 8.9,
    views: 89700,
    authorName: '日剧迷小优',
  },
  {
    id: 'article-3',
    title: 'K-POP新世代：2026年最具潜力的五组新人团体',
    excerpt: '2026年韩国乐坛新人辈出，从大型企划社到中小公司，一批实力与颜值兼备的新人团体正在改写K-POP的版图。本文盘点五组最值得关注的新人。',
    content: `<p>2026年的K-POP市场依旧竞争激烈，但新人的涌现从未停止。在BTS、BLACKPINK等顶流团体成员陆续展开个人活动的同时，新一代偶像团体正在快速崛起。</p><p><strong>NEXUS</strong>——SM娱乐2026年重磅推出的七人男团，出道曲《INFINITY》一经发布即登顶Melon实时榜。团队成员平均年龄19岁，兼具出色的唱跳实力与创作能力。</p><p><strong>LUNA GLOW</strong>——HYBE旗下新女团，以独特的"月光"概念出道，音乐风格融合电子与R&B，视觉美学精致统一，出道专辑首周销量突破80万张。</p><p>此外，JYP的跨国男团<strong>CROSSROAD</strong>、STARSHIP的新女团<strong>WAV</strong>以及独立厂牌推出的另类R&B二人组<strong>DUST</strong>，都在各自领域展现了令人瞩目的潜力。</p><p>K-POP的下一个十年，或许正由这些新人开启。</p>`,
    categoryId: 'korea-music',
    categoryName: '韩国音乐',
    region: '韩国',
    type: '音乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20Korean%20stage%20performance%20with%20vibrant%20pink%20neon%20lighting%2C%20minimalist%20composition%2C%20modern%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20concert%20atmosphere%2C%20no%20text&width=800&height=450&seq=kpop-new-groups-2026&orientation=landscape',
    tags: ['K-POP', '新人团体', '2026', '韩国音乐'],
    publishedAt: '2026-08-05',
    rating: 8.7,
    views: 102300,
    authorName: '韩流观察员Jay',
  },
  {
    id: 'article-4',
    title: '2026年奥斯卡最佳影片提名作品全面解析',
    excerpt: '第98届奥斯卡金像奖最佳影片提名名单已揭晓，十部风格各异的佳作将角逐最高荣誉。本文带您逐一解读每部提名作品的亮点与获奖前景。',
    content: `<p>第98届奥斯卡金像奖提名名单于近日公布，最佳影片单元的十部提名作品涵盖了从独立制作到商业大片的广泛光谱，体现了当下好莱坞创作的多元面貌。</p><p>本届大热包括一部以20世纪60年代民权运动为背景的历史剧情片，凭借精湛的群像表演与史诗般的叙事格局领跑提名数。另一部强有力的竞争者是讲述移民家庭故事的独立电影，以细腻的情感刻画获得影评人一致好评。</p><p>科幻类型在本届也有亮眼表现，一部探讨人工智能与人类关系的原创剧本作品入围，标志着学院对类型片的持续开放态度。同时，一部来自欧洲的合拍艺术片以独特的视觉语言获得关注。</p><p>无论最终花落谁家，本届提名名单已经展现了好莱坞在叙事多样性方面的进步。</p>`,
    categoryId: 'oumei-movies',
    categoryName: '欧美电影',
    region: '欧美',
    type: '电影',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20Oscar%20statuette%20silhouette%20against%20dark%20theater%20curtain%20background%20with%20warm%20spotlight%2C%20minimalist%20luxurious%20composition%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=oscar-2026-nominees&orientation=landscape',
    tags: ['奥斯卡', '电影', '提名', '2026'],
    publishedAt: '2026-08-03',
    rating: 9.1,
    views: 156400,
    authorName: '奥斯卡观察员',
  },
  {
    id: 'article-5',
    title: '2026上半年日本动画电影票房TOP10盘点',
    excerpt: '2026年上半年日本动画电影市场持续火热，多部作品票房突破百亿日元。本文将盘点上半年最卖座的十部动画电影，看看你错过了哪几部。',
    content: `<p>日本动画电影市场在2026年上半年延续了强劲的增长势头，根据日本电影制作者联盟发布的数据，上半年动画电影总票房较去年同期增长15%。</p><p>排名第一的是新海诚导演的最新作品，延续了其"灾难三部曲"之后的全新风格尝试，上映两个月票房突破200亿日元。紧随其后的是《鬼灭之刃》系列的第三部剧场版，凭借强大的粉丝基础与精良的制作，票房同样轻松破百亿。</p><p>值得关注的是，一部原创SF动画电影以黑马之姿闯入前五，其独特的赛博朋克美学与深刻的哲学主题引发广泛讨论。此外，吉卜力工作室时隔多年的新作也位列其中。</p><p>下半年还有多部重磅作品蓄势待发，2026年日本动画电影全年总票房有望再创新高。</p>`,
    categoryId: 'japan-movies',
    categoryName: '日本电影',
    region: '日本',
    type: '电影',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20cinema%20exterior%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20evening%20light%2C%20minimalist%20composition%2C%20clean%20background%2C%20editorial%20photography%20style%2C%20no%20text&width=800&height=450&seq=japan-anime-box-office-2026&orientation=landscape',
    tags: ['日本动画', '票房', '2026', '剧场版'],
    publishedAt: '2026-08-01',
    rating: 8.8,
    views: 98700,
    authorName: '动漫观察者',
  },
  {
    id: 'article-6',
    title: '泰勒·斯威夫特新专辑《Cosmic》深度乐评：一次星际漫游',
    excerpt: '泰勒·斯威夫特第13张录音室专辑《Cosmic》正式发行，这张以太空与宇宙为概念隐喻的专辑，是她迄今为止最具实验性的作品。本文从词曲、制作与概念三个层面深度解析。',
    content: `<p>泰勒·斯威夫特的第13张录音室专辑《Cosmic》于2026年8月1日正式发行，这张专辑从宣布之日就引发了全球乐迷的狂热期待。"13"是泰勒的幸运数字，而这张第13张专辑也确实没有让人失望。</p><p>《Cosmic》共收录16首歌曲，以太空探索为叙事框架，实则探讨了孤独、连接、自我认知等普世主题。泰勒在专辑中大量运用了合成器与空间音效，与她以往以吉他或钢琴为主导的制作风格形成鲜明对比。</p><p>开场曲《Launch》以倒计时音效与渐强的合成器铺陈，瞬间将听众带入太空旅行的情境中。主打歌《Orbit》是一首关于无法逃离却又甘愿沉溺的情感关系的中速流行曲，旋律抓耳的同时歌词深度依旧。</p><p>整张专辑的概念统一性令人惊叹——从歌词中的天文隐喻到制作中的空间感营造，泰勒完成了一次大胆而成功的音乐实验。</p>`,
    categoryId: 'oumei-music',
    categoryName: '欧美音乐',
    region: '欧美',
    type: '音乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dreamy%20cosmic%20nebula%20with%20soft%20pastel%20pink%20tones%2C%20ethereal%20starlight%2C%20minimalist%20space%20composition%2C%20editorial%20photography%20style%2C%20clean%20atmospheric%20background%2C%20no%20text&width=800&height=450&seq=taylor-swift-cosmic-album&orientation=landscape',
    tags: ['泰勒·斯威夫特', '专辑', '乐评', '欧美音乐'],
    publishedAt: '2026-08-10',
    rating: 9.4,
    views: 234500,
    authorName: '音乐编辑艾米',
  },
  {
    id: 'article-7',
    title: '《黑暗荣耀》编剧新作《审判者》开播：社会派复仇剧的又一次突破',
    excerpt: '凭《黑暗荣耀》享誉全球的编剧金银淑携新作《审判者》回归，宋慧乔再次担纲主演。这部聚焦司法系统的社会派剧集，能否再创辉煌？',
    content: `<p>金银淑编剧与宋慧乔的再度合作——《审判者》于2026年8月首播，迅速成为话题焦点。与《黑暗荣耀》聚焦校园暴力不同，《审判者》将目光投向了韩国司法系统。</p><p>宋慧乔饰演的女主角是一名因司法漏洞而失去家人的受害者，她以法院书记官的身份潜伏多年，用自己的方式寻找真相与正义。剧本延续了金银淑对社会阴暗面毫不留情的揭露风格，同时加入了更多法律专业细节。</p><p>首播两集收视率突破15%，位居同时段第一。评论界普遍认为，《审判者》在保持类型剧娱乐性的同时，对司法制度提出了有力拷问。</p><p>宋慧乔的表演再次证明了她驾驭复杂角色的能力——从隐忍到爆发，从脆弱到坚韧，每一个层次都精准到位。</p>`,
    categoryId: 'korea-tv',
    categoryName: '韩国剧集',
    region: '韩国',
    type: '剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20courtroom%20interior%20with%20dramatic%20lighting%20and%20solemn%20atmosphere%2C%20minimalist%20composition%2C%20warm%20wooden%20tones%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=the-judge-kdrama-2026&orientation=landscape',
    tags: ['韩剧', '金银淑', '宋慧乔', '社会派'],
    publishedAt: '2026-08-09',
    rating: 9.0,
    views: 189200,
    authorName: '韩剧分析师',
  },
  {
    id: 'article-8',
    title: '韩国电影《破晓》戛纳获奖：新世代导演的国际突围',
    excerpt: '韩国新锐导演朴赞明执导的《破晓》在第79届戛纳电影节斩获评审团大奖，标志着韩国电影新世代的全面崛起。',
    content: `<p>第79届戛纳电影节落下帷幕，韩国导演朴赞明的第二部长片《破晓》一举拿下评审团大奖，成为本届电影节最大的惊喜之一。</p><p>《破晓》讲述了一个发生在韩国乡村的寓言式故事——一个即将被淹没的村庄里，最后一位坚守的老人与一名城市规划师之间发生的冲突与和解。影片以诗意的黑白影像，探讨了现代化进程中的传统消逝、代际矛盾与人性尊严。</p><p>评审团主席在颁奖词中评价："《破晓》以一种温柔而坚定的方式提醒我们，在发展的洪流中，个体的声音与记忆同样重要。"</p><p>朴赞明年仅34岁，是继奉俊昊、朴赞郁之后又一位在国际舞台上崭露头角的韩国导演。他的成功也预示着韩国电影新老交替的顺利进行。</p>`,
    categoryId: 'korea-movies',
    categoryName: '韩国电影',
    region: '韩国',
    type: '电影',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20rural%20village%20at%20dawn%20with%20mist%20over%20rice%20fields%2C%20soft%20morning%20light%2C%20minimalist%20cinematic%20composition%2C%20black%20and%20white%20aesthetic%2C%20clean%20atmospheric%20background%2C%20no%20text&width=800&height=450&seq=dawn-korean-film-cannes&orientation=landscape',
    tags: ['韩国电影', '戛纳', '朴赞明', '获奖'],
    publishedAt: '2026-07-28',
    rating: 9.2,
    views: 87600,
    authorName: '电影节特派员',
  },
  {
    id: 'article-9',
    title: '2026年Billboard夏季热门单曲：十首必听的欧美流行',
    excerpt: '2026年Billboard Hot 100夏季榜单揭晓，从流行到嘻哈，从R&B到电子，十首霸榜热单一次性全收录，为你的夏季歌单注入新鲜血液。',
    content: `<p>2026年的Billboard夏季榜单呈现出了令人兴奋的多元化趋势。流媒体数据的权重进一步提升，TikTok热门歌曲对榜单的影响力持续增强。</p><p>登顶夏季榜首的是一首融合了拉丁节奏与电子元素的流行舞曲，由波多黎各新星与美国制作人联手打造，已在全球范围内引发翻跳热潮。紧随其后的是一首深情的R&B慢歌，来自一位首次进入前十的英国独立歌手。</p><p>值得注意的是，本季榜单中有三首非英语歌曲进入前十，包括一首韩语流行、一首西班牙语雷鬼与一首法语电子，反映出美国音乐市场的国际化趋势愈发明显。</p><p>此外，两位老牌天王的回归单曲也双双进入前五，证明了经典魅力的持久不衰。这个夏天，无论你偏好哪种曲风，这份榜单都能满足你。</p>`,
    categoryId: 'oumei-music',
    categoryName: '欧美音乐',
    region: '欧美',
    type: '音乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20music%20festival%20crowd%20silhouette%20against%20colorful%20sunset%20sky%2C%20warm%20golden%20hour%20lighting%2C%20minimalist%20composition%2C%20editorial%20photography%20style%2C%20clean%20atmospheric%20background%2C%20no%20text&width=800&height=450&seq=billboard-summer-hits-2026&orientation=landscape',
    tags: ['Billboard', '热门单曲', '夏季', '欧美流行'],
    publishedAt: '2026-07-25',
    rating: 8.6,
    views: 143200,
    authorName: '音乐趋势分析',
  },
  {
    id: 'article-10',
    title: '《进击的巨人》完结篇五年后：这部作品如何改变了动画产业',
    excerpt: '《进击的巨人》动画完结五年后，回望这部现象级作品对全球动画产业格局、叙事方式与粉丝文化的深远影响。',
    content: `<p>距离《进击的巨人》动画最终章播出已经过去五年，但这部作品对动画产业的影响仍在持续发酵。谏山创的原作漫画与WIT STUDIO及MAPPA的动画改编，共同创造了一个跨越文化边界的全球现象。</p><p>在产业层面，《进击的巨人》的成功证明了成人向、暗黑风格动画在全球市场的巨大潜力。它的流媒体播放数据至今仍是动画类别的标杆，推动了Netflix、Crunchyroll等平台对日本动画版权的巨额投资。</p><p>在叙事层面，该作品打破了许多传统少年漫画的叙事框架——主角并非绝对的正义化身，敌人也不是纯粹的邪恶。道德灰度、政治隐喻、存在主义思考等元素的深度融入，提升了动画这一媒介的艺术表达边界。</p><p>更重要的是，《进击的巨人》培养了一代愿意为深度叙事买单的全球观众，为后来更多大胆创新的动画作品铺平了道路。</p>`,
    categoryId: 'japan-tv',
    categoryName: '日本剧集',
    region: '日本',
    type: '剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20colossal%20wall%20silhouette%20against%20sunset%20sky%2C%20cinematic%20anime%20inspired%20composition%2C%20warm%20orange%20and%20dark%20contrast%2C%20minimalist%20editorial%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=attack-on-titan-legacy&orientation=landscape',
    tags: ['进击的巨人', '动画产业', '回顾', '日本动漫'],
    publishedAt: '2026-07-20',
    rating: 9.5,
    views: 210300,
    authorName: '动漫深度观察',
  },
  {
    id: 'article-11',
    title: 'J-POP传奇：宇多田光出道25周年纪念特辑',
    excerpt: '宇多田光出道25周年，这位J-POP天后的音乐旅程不仅是个人成长史，更是日本流行音乐变迁的缩影。',
    content: `<p>2026年，宇多田光迎来了出道25周年。从1999年以《Automatic》横空出世的15岁天才少女，到如今日本流行音乐最具影响力的艺术家之一，宇多田光的音乐旅程是一部不断突破的传奇。</p><p>纪念专辑《25》收录了她从出道至今的经典曲目重制版，以及三首全新创作。制作方面，宇多田光与多位国际制作人合作，为经典作品注入了现代化的编曲与音色。</p><p>回顾25年，从R&B风格的早期作品，到实验电子元素的中期探索，再到近年融合多元文化的成熟表达，宇多田光从未停止进化。她的音乐不仅影响了一代日本音乐人，在全球范围内也拥有广泛的听众基础。</p><p>纪念巡演将于今年秋季从东京巨蛋启程，覆盖亚洲、北美与欧洲的15个城市。</p>`,
    categoryId: 'japan-music',
    categoryName: '日本音乐',
    region: '日本',
    type: '音乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20recording%20studio%20with%20vintage%20microphone%20and%20warm%20ambient%20lighting%2C%20minimalist%20elegant%20composition%2C%20soft%20golden%20tones%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=utada-hikaru-25th&orientation=landscape',
    tags: ['宇多田光', 'J-POP', '25周年', '日本音乐'],
    publishedAt: '2026-07-15',
    rating: 9.1,
    views: 76500,
    authorName: '日本音乐通',
  },
  {
    id: 'article-12',
    title: '2026年Netflix韩国原创内容战略分析：从《鱿鱼游戏》到全球化布局',
    excerpt: 'Netflix在韩国市场的投入持续加码，2026年计划推出超过30部韩国原创作品。本文分析Netflix的韩国内容战略及其对全球流媒体格局的影响。',
    content: `<p>自《鱿鱼游戏》在全球范围内取得现象级成功后，Netflix对韩国原创内容的投资呈指数级增长。2026年，Netflix宣布将在韩国市场投入超过1万亿韩元，计划推出超过30部原创电影与剧集。</p><p>这一战略的背后逻辑十分清晰：韩国内容在亚洲、拉美乃至欧美市场都展现出了强大的跨文化吸引力。从《黑暗荣耀》到《体能之巅》，Netflix的韩国原创内容覆盖了剧情、综艺、纪录片等多个品类。</p><p>值得关注的是，Netflix正在从单纯的"购买与分发"模式转向"深度合作制作"——与韩国顶级编剧和导演签订独家合作协议，深度参与创意开发。同时，AI翻译技术的进步使得韩语内容的全球同步上线成为可能。</p><p>然而，竞争对手也不甘示弱。Disney+与Apple TV+同样加大了对韩国内容的投入，流媒体平台之间的"韩流争夺战"才刚刚开始。</p>`,
    categoryId: 'korea-tv',
    categoryName: '韩国剧集',
    region: '韩国',
    type: '剧集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20film%20production%20set%20with%20professional%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20minimalist%20cinematic%20composition%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20no%20text&width=800&height=450&seq=netflix-korea-strategy-2026&orientation=landscape',
    tags: ['Netflix', '韩国原创', '流媒体', '韩流'],
    publishedAt: '2026-07-10',
    rating: 8.5,
    views: 67800,
    authorName: '流媒体观察家',
  },
];